import { BehaviorSubject } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'corner-info',
  templateUrl: './corner-info.component.html',
  styleUrls: ['./corner-info.component.css']
})
export class CornerInfoComponent implements OnInit {
  canvas_width = 300;
  canvas_height = 300;
  private infoSubject = new BehaviorSubject<string[]>(['hello', 'ok']);
  private positionSubject = new BehaviorSubject<string>('bottom-left');
  info$ = this.infoSubject.asObservable();
  position$ = this.positionSubject.asObservable();

  @Input()
  get info(): string[] {
    return this.infoSubject.value;
  }
  set info(i: string[]) {
    this.infoSubject.next(i);
  }
  @Input()
  get position(): string {
    return this.positionSubject.value;
  }
  set position(p: string) {
    this.positionSubject.next(p);
  }
  constructor() { }

  ngOnInit() {
  }

}
